<angular2-multiselect [data]="dropdownList"
                      [(ngModel)]="selectedItems"
                      [settings]="dropdownSettings"
                      (onSelect)="onItemSelect()"
                      (onDeSelect)="onItemDeSelect()"
                      (onSelectAll)="onSelectAll()"
                      (onDeSelectAll)="onDeSelectAll()">
                                              </angular2-multiselect>